import 'client-only';

import { type Brand } from '@/consts/brands';
import {
  type TreatmentCategory,
  TreatmentCategoryIds,
} from '@/consts/treatmentCategories';
import { type CheckoutInvoiceData } from '@/types/cartCheckout/types';
import { post } from '@/utils/http/client';
import { urls } from '@/utils/urls';

const processCartCheckout = async ({
  brand,
  treatmentCategory,
  paymentToken,
}: {
  brand: Brand;
  treatmentCategory: TreatmentCategory;
  paymentToken: string;
}): Promise<CheckoutInvoiceData> => {
  const response = await post(urls[brand].api.checkout.cart.processCheckout, {
    treatmentCategoryId: TreatmentCategoryIds[treatmentCategory],
    paymentToken,
  });

  return response?.data;
};

export const CheckoutService = {
  processCartCheckout,
};
